"use client"

import { Button } from "@/components/ui/button"
import { ArrowRight } from "lucide-react"
import { useLanguage } from "@/lib/i18n/language-context"

export function CTASection() {
  const { t } = useLanguage()

  return (
    <section className="px-4 py-20 md:px-6 md:py-32">
      <div className="container mx-auto">
        <div className="relative overflow-hidden rounded-2xl border border-border bg-gradient-to-br from-primary/10 via-accent/10 to-background p-8 md:p-16">
          <div className="relative z-10 mx-auto max-w-3xl text-center">
            <h2 className="mb-4 text-balance text-3xl font-bold tracking-tight md:text-4xl lg:text-5xl">
              {t.ctaTitle}
            </h2>
            <p className="mb-8 text-pretty text-lg text-muted-foreground md:text-xl">{t.ctaDescription}</p>
            <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
              <Button size="lg" className="min-w-[200px] gap-2">
                {t.startFreeTrial}
                <ArrowRight className="h-4 w-4" />
              </Button>
              <Button size="lg" variant="outline" className="min-w-[200px] bg-transparent">
                {t.contactSales}
              </Button>
            </div>
          </div>

          <div className="absolute -right-20 -top-20 h-64 w-64 rounded-full bg-primary/20 blur-3xl" />
          <div className="absolute -bottom-20 -left-20 h-64 w-64 rounded-full bg-accent/20 blur-3xl" />
        </div>
      </div>
    </section>
  )
}
